// İSG uzmanı portalı — detay sayfası ana ızgarası (owner kararı, S33 planı §layout; bkz.
// `docs/plans/S33-carbon-reskin.md`). 2a'nın `grid-cols-[336px_minmax(0,1fr)]`'i YALNIZ
// **≥1440px**'te doğrudur — altında sol sütunu 336px'e sabitlemek sağ sütunu (Tabs+Tile,
// özellikle Kapsanan Personel tablosu) ~592px'e sıkıştırıyor, bu da HEM sayfa geneli yatay
// kaydırmaya (S33 Slice 3 canlı QA'da 1200px'te ölçülen 23px) HEM tablonun kendi iç
// kaydırmasına yol açıyordu (iki ayrı QA turu).
//
// **Owner kararı — iki durum:**
// - **<1440px:** `meta` (Bilgiler + İlerleme Tile'ları) YAN YANA 2 eşit sütun (`gap-4`) ÜSTTE;
//   `content` ([uyarı] → Tabs → Tile) TAM GENİŞLİK ALTTA. Personel tablosu artık 336px'lik dar
//   sütuna değil, sayfanın (sidenav + `px-8` dışında kalan) TAM genişliğine (~700-1200px)
//   yerleşir — 1024/1200/1280'de ne sayfa ne tablo kaydırma ister.
// - **≥1440px:** 2a'nın kendisi — sol 336px sabit sütun (`meta` ALT ALTA döner), sağ
//   `minmax(0,1fr)` (`content`).
//
// Tek markup, `min-[1440px]:` (Tailwind v4 rastgele/arbitrary breakpoint varyantı) ile koşullu
// sınıflar — JS medya sorgusu YOK, `lg`/`xl` gibi VAR OLAN, başka ekranların (ör.
// `DayListTab.tsx`, `SecuritySiteSession.tsx`) zaten kullandığı adlı breakpoint'ler DEĞİŞTİRİLMEDİ
// (1440 bu ikisinin arasında, Tailwind'in varsayılan ölçeğinde YOK — `--breakpoint-xl`'i global
// override etmek `xl:`'nin VAR OLAN, alakasız tüketicilerini de kaydırırdı).
//
// **Paylaşılan (S37-0).** Önce web-expert'te app-local'di; web-supplier'ın izin detayı gerçek ikinci
// tüketici olduğundan buraya taşındı (davranış/sınıflar DEĞİŞMEDİ).
import type { ReactNode } from 'react';

interface DetailLayoutProps {
  /**
   * Meta alanı (bu dilimde: Bilgiler + İlerleme Tile'ları) — İKİ doğrudan çocuk BEKLENİR
   * (<1440px'teki `grid-cols-2` ile eşleşir; üç ya da bir çocuk düzeni bozar).
   */
  meta: ReactNode;
  /** İçerik alanı (bu dilimde: [uyarı] → Tabs → Tile). */
  content: ReactNode;
}

export function DetailLayout({ meta, content }: DetailLayoutProps) {
  return (
    <div className="flex flex-col gap-6 min-[1440px]:grid min-[1440px]:grid-cols-[336px_minmax(0,1fr)] min-[1440px]:gap-x-8 min-[1440px]:gap-y-0">
      <div className="grid grid-cols-2 gap-4 min-[1440px]:flex min-[1440px]:flex-col min-[1440px]:gap-4">
        {meta}
      </div>
      <div className="min-w-0">{content}</div>
    </div>
  );
}
